import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {Restaurant} from "../../shared/model/restaurant";
import {Router} from "@angular/router";
import {UserService} from "../../shared/services/user/user.service";
import {AuthService} from "../../shared/security/auth.service";


@Component({
  selector: 'restaurant-table',
  templateUrl: 'restaurant-table.component.html',
  styleUrls: ['restaurant-table.component.css']
})
export class RestaurantTableComponent implements OnInit {
  private restaurants: Restaurant[];
  title = 'SRVPLS !';

  public rows:Array<any> = [];
  public columns:Array<any> = [
    {title: 'Restaurant', name: 'restaurant', filtering: {filterString: '', placeholder: 'Filter by name'}, sort:''},
    {title: 'City', className: ['city-header', 'text-success'], name: 'city', sort: '', filtering: {filterString: '', placeholder: 'Filter by city.'}},
    // {title: 'Active', className:['active'], name:'isActive', sort:'', filtering: {filterString: true, placeholder: 'Active'}},
    {title: '', ClassName:'edit', name: 'edit', sort:''},
    // {title: 'Active', className: 'text-warning', name: 'isActive'}

  ];
  public page:number = 1;
  public itemsPerPage:number = 5;
  public maxSize:number = 5;
  public numPages:number = 1;
  public length:number = 0;

  public config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
    className: ['table-striped', 'table-bordered','ng-table']
  };

  private data: Array<any>;

  private showSpiner: boolean = false;

  private currentUserId:string;

  // @Output('restaurant')


  // @Output() restaurantEmitter : EventEmitter<any> = new EventEmitter();

  @Output() restaurantEmitter : EventEmitter<Restaurant> = new EventEmitter<Restaurant>()

  private backgroundColor:string = "";

  constructor(
      private restaurantservice:RestaurantService,
      private router: Router,
      private userservice: UserService,
      private authservice: AuthService
    )
    {
      // console.log(this.title);
    }

  ngOnInit() {

    const userKey$ = this.authservice.getUserKey();
    userKey$
      .subscribe((userkey)=>{
        this.currentUserId = userkey;
        this.restaurantservice.getRestaurantsforUserAsAdmin(this.currentUserId)
          .subscribe(restaurants => {
              this.restaurants = restaurants;
              this.data = this.restaurants;
              this.length = this.data.length;
              this.onChangeTable(this.config);
            }
          );

      })





  }

  create(){
      let navigateRoute = '/restaurants/create/';
    this.router.navigate([navigateRoute]);
  }

  public onCellClick(data: any): any {

    // console.log(data.column);

    let restaurantId = data.row.$key;

    let navigateRoute = './restaurants/'+ restaurantId

    if (data.column == "edit"){

       navigateRoute = navigateRoute +'/edit';


    }


    this.router.navigate([navigateRoute]);

  }





  private getRestaurants() {
    this.restaurantservice.getAllRestaurants().subscribe(restaurants => this.restaurants = restaurants);
    // this.Restaurants = this.restaurantservice.getRestaurants();
  }


  public changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string = void 0;
    let sort:string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name].toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }


  public onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}



// WEBPACK FOOTER //
// ./src/app/restaurant/restaurant-table/restaurant-table.component.ts